import Api from './Api';

export default {
    GetTriggersList() {
        return Api().get(`/api/marketingautomation/gettriggers`)
    },
    GetActionsList() {
        return Api().get(`/api/marketingautomation/getactions`)
    },
    GetFlowControlsList() {
        return Api().get(`/api/marketingautomation/getflowcontrols`)
    },
    GetConditionsList() {
        return Api().get(`/api/marketingautomation/getconditions`)
    },
    GetActionDataTypes(){
        return Api().get(`/api/marketingautomation/getactiondatatypes`)
    },
    GetConditionRules(){
        return Api().get(`/api/marketingautomation/getconditionrules`)
    },
    GetEmailTemplateList() {
        return Api().get(`/api/marketingautomation/getemailtemplates`)
    },
    GetSmsTemplateList(){
        return Api().get(`/api/marketingautomation/getsmstemplates`)
    },
    GetSegments(){
        return Api().get(`/api/marketingautomation/getsegments`)
    },
    GetAllUserJourney(payload) {
        return Api().post(`/api/marketingautomation/getalluserjourney`, payload)
    },
    GetSingleUserJourneyData(payload) {
        return Api().get(`/api/marketingautomation/getsingleuserjourney/${payload}`)
    },
    AddUserJourney(payload) {
        return Api().post(`/api/marketingautomation/addtouserjourney`, payload)
    },
    UpdateUserJourney(payload) {
        return Api().put(`/api/marketingautomation/updateuserjourney`, payload)
    }
}



// WEBPACK FOOTER //
// ./src/services/UserJourneyService.js